import { EClassicViewMode } from '../../../enums/games/classic/classic-view-mode.enum';

export type TClassicViewMode = EClassicViewMode.GRID | EClassicViewMode.LIST;
